import { IndexPrComponentMainDiv } from "../../styles/indexcomponentsstyles/indexprcomponentstyles";
import Logo from "./assets/bugzi logo 2.png";


const IndexPrComponent = () => {
  return (
    <IndexPrComponentMainDiv>
      <div>
        <div className="index-pr-svg-holder">
          <svg viewBox=" 0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur
                  in="SourceGraphic"
                  stdDeviation="3"
                  result="blur"
                />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <path
              d="
                M -30,50 C 20,50 40,50 58,50 C 70,50 80,50 80,60 L 80, 68  C 80,68 80,78 90,76 L 90, 76 
                M -30,50 C 20,50 40,50 58,50 C 70,50 80,50 80,40 L 80, 31  C 80,31 80,22 90,24 L 90, 24 
      M -10,50 L 90, 50 "
              fill="none"
              stroke="rgba(255, 255, 255, 0.08)"
              stroke-width=".5"
            />{" "}
            <path
              className="index-pr-running-line"
             
               d="
                M -30,50 C 20,50 40,50 58,50 C 70,50 80,50 80,60 L 80, 68  C 80,68 80,78 90,76 L 90, 76 
                M -30,50 C 20,50 40,50 58,50 C 70,50 80,50 80,40 L 80, 31  C 80,31 80,22 90,24 L 90, 24 
      M -30,50 L 90, 50 "
              fill="none"
              filter="url(#glow)"
              pathLength="1"
              stroke=""
              stroke-width=".5"
            />{" "}
          </svg>
        </div>


        <div className="index-pr-container">
          <div className="index-pr-card-container index-pr-agent-card-container">
            <div>
              <div className="index-pr-card-text-container">
                <h3> Agent </h3>
              </div>
            </div>
          </div>
          <div className="index-pr-card-container index-pr-logo-card-container">
            <div>
              <div className="index-pr-card-logo-container">
                <img src={Logo} alt="bugzi" />
              </div>
            </div>
          </div>
          <div className="index-pr-cards-container">
            <div className="index-pr-card-container index-pr-action-card-container">
              <div>
                <div className="index-pr-card-text-container">
                  <p> Agent </p>
                </div>
              </div>
            </div>
            <div className="index-pr-card-container index-pr-action-card-container">
              <div>
                <div className="index-pr-card-text-container">
                  <p> Agent </p>
                </div>
              </div>
            </div>{" "}
            <div className="index-pr-card-container index-pr-action-card-container">
              <div>
                <div className="index-pr-card-text-container">
                  <p> Agent Agent </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </IndexPrComponentMainDiv>
  );
};

export default IndexPrComponent;
